import queryString from 'query-string';
import { pathToRegexp } from 'path-to-regexp';
import { isBrowser, getWindow } from '@cap/ssr-common-utils';

export function getSearch(href?: string) {
  const window = getWindow();
  return queryString.parseUrl(href ?? window.location.href)?.query || {};
}

export function isAbsoluteURL(url: string) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  // eslint-disable-next-line no-useless-escape
  return /^([a-z][a-z\d\\+\-\\.]*:)?\/\//i.test(url);
}

export function isSameOriginURL(url: string, baseURL = '', location?: Location) {
  if (isBrowser) {
    const window = getWindow();
    const { origin, protocol = '' } = location ?? window.location;
    let targetUrl = url;
    if (isAbsoluteURL(targetUrl)) {
      if (/^\/\//i.test(targetUrl)) {
        targetUrl = `${protocol.replace(/:+$/, '')}:${targetUrl}`;
      }
    } else {
      targetUrl = url ? `${baseURL.replace(/\/+$/, '')}/${url.replace(/^\/+/, '')}` : baseURL;
    }
    if (isAbsoluteURL(targetUrl) && !new RegExp(`^${origin}`, 'i').test(targetUrl)) {
      return false;
    }
  }
  return true;
}

/**
 * 获取Url传递的通用参数
 */
export function getCommonParams(href?: string) {
  const {
    source,
    mtdxSource,
    // business,
    // from,
    // tenant = 'mtbbk',
    // clientName,
    // mpGray,
    enterResource,
    // pageId,
    // // 消息push浏览器mock标识
    // __msgMock,
    // sUId,
    // sUType,
    // hideNavbar,
  } = getSearch(href);
  const params = {
    source,
    mtdxSource,
    // business,
    // from,
    // tenant,
    // clientName: clientName || CLIENT_NAME_MAP.CYB_H5, // 客户端名称，与小程序保持一致（cyb、kdzn）。默认cyb_h5
    // mpGray,
    enterResource,
    // pageId, // 区分首页的页面ID
    // // 消息push浏览器mock标识
    // __msgMock,
    // sUId, // 用户ID
    // sUType, // 用户类型
    // hideNavbar, // 是否隐藏首页的navbar
  };
  return params;
}

/**
 * 为传入 url 添加通用参数
 */
export function appendCommonQuery(url: string) {
  const params = getCommonParams();

  return queryString.stringifyUrl({
    url,
    query: {
      ...params,
    },
  });
}

/**
 * 使用pathToRegexp格式化路由参数
 * @param {*} url
 * @param {*} path
 */
export function parsePathParams(url = '', path = '/(.*)') {
  const window = getWindow();
  const currUrl = url || window.location.pathname;
  const keys: any = [];
  const regexp = pathToRegexp(path, keys, { end: false });
  const matchs = regexp.exec(currUrl);
  const params = {};
  if (matchs) {
    (keys || []).forEach((key: any, idx: number) => {
      const val = matchs[idx + 1];
      if (val) {
        // @ts-ignore
        params[key.name] = val;
      }
    });
  }
  return params as { [key: string]: string };
}

export function getTenant(href?: string): string {
  const window = getWindow();
  const { query } = queryString.parseUrl(href || window.location.href);
  return (query.tenant || 'mtbbk') as string;
}

export function csrfSafeMethod(method: string) {
  // these HTTP methods do not require CSRF protection
  return /^(GET|HEAD|OPTIONS|TRACE)$/.test(method);
}

/**
 * 域名白名单检测, sankuai.com,meituan.com,dianping.com,51ping.com,baobaoaichi,dpurl.cn
 * @param {*} url 匹配的url
 * @param {*} whiteList 自定义扩展白名单列表
 * @returns
 */
export const domainWhiteListCheck = (url: string, whiteList = []) => {
  const domain = [
    /^https?:\/\/[^/#?@]+\.sankuai\.com(:[\d]+)?\//,
    /^https?:\/\/[^/#?@]+\.meituan\.com(:[\d]+)?\//,
    /^https?:\/\/[^/#?@]+\.dianping\.com(:[\d]+)?\//,
    /^https?:\/\/[^/#?@]+\.dpurl\.cn(:[\d]+)?\//, // 点评网
    /^https?:\/\/[^/#?@]+\.51ping\.com(:[\d]+)?\//,
    /^https?:\/\/([^/#?@]+\.)?vss.baobaoaichi\.cn(:[\d]+)?\//, // 小象生鲜
    /^https?:\/\/localhost(:[\d]+)?\//,
    /^https?:\/\/127.0.0.1(:[\d]+)?\//,
    // /^https?:\/\/([\d]+\.){3}[\d]+(:[\d]+)?\//,
  ];

  // 过滤掉javascript:开头的url
  if (/^\s*javascript\s*:/.test(url) || /(<script>|alert\()/.test(url)) {
    return false;
  }
  // 非绝对路径，直接返回true
  if (!isAbsoluteURL(url)) return true;

  if (
    domain.some((reg) => reg.test(url)) ||
    (whiteList || []).some((w) => !(url || '').match(new RegExp(w)))
  ) {
    return true;
  }
  return false;
};
